import { render } from "./RemoteWork.vue?vue&type=template&id=380560da&scoped=true"
import script from "./RemoteWork.vue?vue&type=script&lang=js"
export * from "./RemoteWork.vue?vue&type=script&lang=js"

import "./RemoteWork.vue?vue&type=style&index=0&id=380560da&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380560da"]])

export default __exports__